import React, { Fragment } from "react";
import { Descriptions, Row, Card as AntdCard } from "antd";
import PaymentAccountsView from "../../../components/PaymentsAccountsView";
import ContactDetailsView from "../../../components/ContactDetailsView";
import {
  AssociatedAddress,
  AssociatedEmail,
  AssociatedPhone,
  CompanyContact,
  Customer,
  Director,
  Opportunity,
  OpportunityProspectTypes,
  PaginatedResourcePageSelected,
  PaymentAccount,
  FileUpload,
} from "../../../helpers/shared-interfaces";
import TagsSection from "../../../components/TagsSection";
import EntitledSection from "../../../components/EntitledSection";
import entitlements from "../../../config/entitlements";


interface Props {
  opportunity: Opportunity;
  editButton: JSX.Element;
  onAddEmail?: () => void;
  onAddPhone?: () => void;
  onAddAddress?: () => void;
  onMakePrimaryEmail?: (email: AssociatedEmail) => void;
  onMakePrimaryPhone?: (phone: AssociatedPhone) => void;
  onMakePrimaryAddress?: (address: AssociatedAddress) => void;
  onEditEmail?: (email: AssociatedEmail) => void;
  onDeleteEmail?: (email: AssociatedEmail) => void;
  onReactivateEmail?: (email: AssociatedEmail) => void;
  onEditPhone?: (phone: AssociatedPhone) => void;
  onDeletePhone?: (phone: AssociatedPhone) => void;
  onReactivatePhone?: (phone: AssociatedPhone) => void;
  onEditAddress?: (address: AssociatedAddress) => void;
  onDeleteAddress?: (address: AssociatedAddress) => void;
  onReactivateAddress?: (address: AssociatedAddress) => void;
  onAddCompanyContact?: () => void;
  onEditCompanyContact?: (contact: CompanyContact) => void;
  onDeleteCompanyContact?: (contact: CompanyContact) => void;
  onAddCompanyDirector?: () => void;
  onDeleteCompanyDirector?: (director: Director) => void;
  onAddDirectorContact?: (director: Director) => void;
  onDeleteDirectorContact?: (contact: string, directorId: string) => void;
  onUploadCompanyInfoFile?: () => void;
  onDeleteCompanyInfoFile?: (id?: string) => void;
  onSetEntityToBeDeleted?: (entity: string) => void;
  onAddPayoutAccount?: () => void;
  onAddDebitAccount?: () => void;
  onEditPayoutAccount?: (account: PaymentAccount) => void;
  onDeletePayoutAccount?: (account: PaymentAccount) => void;
  onEditDebitAccount?: (account: PaymentAccount) => void;
  onDeleteDebitAccount?: (account: PaymentAccount) => void;
  companyPetraId?: string;
  currentEmployees?: { data: Customer[]; totalCount: number };
  formerEmployees?: { data: Customer[]; totalCount: number };
  currentEmployeesPage?: number;
  formerEmployeesPage?: number;
  numberPerPage?: number;
  paginatedResourceNextPage?: (
    page: number,
    paginatedResource: PaginatedResourcePageSelected,
    numberPerPage: number,
  ) => void;
  companyInfoFileUploads?: FileUpload[];
}

export default function (props: Props): JSX.Element {
  const { opportunity, editButton } = props;
  return (
    <Fragment>
      {opportunity.opportunityProspect &&
        opportunity.opportunityProspect.name ===
          OpportunityProspectTypes.institutionalClient && (
          <div>
            {opportunity.company && (
              <Row className="view-opportunity-row">
                <AntdCard
                  title={
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 12 }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        <span>Company</span>
                        {opportunity.company.tags.length > 0 && (
                          <TagsSection
                            compact
                            style={{ margin: 0 }}
                            tags={opportunity.company.tags}
                          />
                        )}
                      </div>
                      <div
                        style={{ marginLeft: "auto", display: "flex", gap: 8 }}
                      >
                        <EntitledSection
                          entitlement={entitlements.Companies.edit}
                        >
                          {editButton}
                        </EntitledSection>
                      </div>
                    </div>
                  }
                >
                  <Descriptions>
                    <Descriptions.Item label={<b>Name</b>} key="Name">
                      {opportunity.company?.name || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label={<b>Petra ID</b>} key="Petra ID">
                      {opportunity.company?.petraId || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label={<b>TIN</b>} key="TIN">
                      {opportunity.company?.tinNumber || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={<b>Date of Establishment</b>}
                      key="dateOfEstablishment"
                    >
                      {opportunity.company?.dateOfEstablishment || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={<b>Former Trustee</b>}
                      key="Trustee"
                    >
                      {opportunity.company?.trustee?.name || "N/A"}
                    </Descriptions.Item>

                    <Descriptions.Item
                      label={<b>Industry Sector</b>}
                      key="Industry Sector"
                    >
                      {opportunity.company?.industrySector?.name || "N/A"}
                    </Descriptions.Item>

                    <Descriptions.Item
                      label={<b>Company Segment</b>}
                      key="Company Segment"
                    >
                      <span>
                        {opportunity.company?.companySegment || "N/A"}
                      </span>
                    </Descriptions.Item>

                    <Descriptions.Item
                      label={<b>Number of Employees</b>}
                      key="Number Of Employees"
                    >
                      {opportunity.company?.numberOfEmployees ?? "N/A"}
                    </Descriptions.Item>

                    <Descriptions.Item
                      label={<b>SSNIT Number</b>}
                      key="ssnitNumber"
                    >
                      {opportunity.company?.ssnitNumber || "N/A"}
                    </Descriptions.Item>

                    <Descriptions.Item
                      label={<b>RDG/ROC Number</b>}
                      key="rocNumber"
                    >
                      {opportunity.company?.rocNumber || "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={<b>Relationship Manager</b>}
                      key="Relationship Manager"
                    >
                      {opportunity.company?.relationshipManager?.name || "N/A"}
                    </Descriptions.Item>
                  </Descriptions>
                </AntdCard>
              </Row>
            )}
          </div>
        )}

      {opportunity.opportunityProspect &&
        opportunity.opportunityProspect.name ===
          OpportunityProspectTypes.institutionalClient && (
          <ContactDetailsView
            editEntitlement={entitlements.Companies.edit}
            phones={opportunity.company?.companyPhones || []}
            emails={opportunity.company?.companyEmails || []}
            adresses={opportunity.company?.companyAddresses || []}
            formerEmployees={
              props.formerEmployees || { data: [], totalCount: 0 }
            }
            currentEmployees={
              props.currentEmployees || { data: [], totalCount: 0 }
            }
            currentEmployeesPage={props.currentEmployeesPage}
            formerEmployeesPage={props.formerEmployeesPage}
            numberPerPage={props.numberPerPage}
            paginatedResourceNextPage={props.paginatedResourceNextPage}
            companyPetraId={
              props.companyPetraId || opportunity.company?.petraId
            }
            style={{ marginBottom: "30px", marginTop: "30px" }}
            onAddEmail={props.onAddEmail}
            onAddPhone={props.onAddPhone}
            onAddAddress={props.onAddAddress}
            onMakePrimaryEmail={props.onMakePrimaryEmail}
            onMakePrimaryPhone={props.onMakePrimaryPhone}
            onMakePrimaryAddress={props.onMakePrimaryAddress}
            onEditEmail={props.onEditEmail}
            onDeleteEmail={props.onDeleteEmail}
            onReactivateEmail={props.onReactivateEmail}
            onEditPhone={props.onEditPhone}
            onDeletePhone={props.onDeletePhone}
            onReactivatePhone={props.onReactivatePhone}
            onEditAddress={props.onEditAddress}
            onDeleteAddress={props.onDeleteAddress}
            onReactivateAddress={props.onReactivateAddress}
            companyContacts={opportunity.company?.companyContacts || []}
            directors={opportunity.company?.directors || []}
            onAddCompanyContact={props.onAddCompanyContact}
            onEditCompanyContact={props.onEditCompanyContact}
            onDeleteCompanyContact={props.onDeleteCompanyContact}
            onAddCompanyDirector={props.onAddCompanyDirector}
            onDeleteCompanyDirector={props.onDeleteCompanyDirector}
            onAddDirectorContact={props.onAddDirectorContact}
            onDeleteDirectorContact={props.onDeleteDirectorContact}
            onUploadCompanyInfoFile={props.onUploadCompanyInfoFile}
            onDeleteCompanyInfoFile={props.onDeleteCompanyInfoFile}
            onSetEntityToBeDeleted={props.onSetEntityToBeDeleted}
            companyInfoFileUploads={
              props.companyInfoFileUploads ||
              opportunity.company?.companyInfoFileUploads ||
              []
            }
          />
        )}

      <PaymentAccountsView
        style={{ marginBottom: "30px" }}
        payoutAccounts={opportunity.company.companyPayoutAccounts}
        bankDetailsTitle="Company Bank Details"
        editEntitlement={entitlements.Companies.edit}
        deleteEntitlement={entitlements.Companies.payoutAccount.delete}
        onAddPayoutAccount={props.onAddPayoutAccount}
        onEditPayoutAccount={props.onEditPayoutAccount}
        onDeletePayoutAccount={props.onDeletePayoutAccount}
      />
    </Fragment>
  );
}
